import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { formatDateTime } from '@/utils/date.utils';
import type { ActionLogFormatted } from '../../../beneficiaries.types';

const columnHelper = createColumnHelper<ActionLogFormatted>();

export const actionLogsColumns = [
  columnHelper.accessor('typeFormatted', {
    id: 'type',
    header: 'Fonction',
    meta: { filterType: 'text' },
  }),
  columnHelper.accessor((row) => row.dateTime, {
    id: 'dateTime',
    header: 'Date et heure',
    size: 200,
    cell: (info) => formatDateTime(info.getValue()),
    meta: { filterType: 'numeric' },
  }),
  columnHelper.accessor('description', {
    id: 'description',
    header: 'Description',
    size: 300,
    meta: { filterType: 'text' },
  }),
  columnHelper.accessor('user.name', {
    header: 'Utilisateur',
    meta: { filterType: 'text' },
  }),
] as ColumnDef<ActionLogFormatted>[];
